import DetectTouch from '@utilities/detect-touch';
import { body } from '@utilities/dom-elements';

const CUSTOM_CLASS = 'c-select--custom';

class CustomSelectBox {
  constructor(element) {
    this.ui = {
      element,
      label: element.querySelector('label') || element.querySelector('.select__label'),
      select: element.querySelector('select'),
      options: [...element.querySelector('select').options],
      labelText: null,
      list: null,
    };

    this.bindMobileEvents();

    if (DetectTouch.touch) return;

    if(this.ui.options.length === 0 ) return;

    this.ui.element.classList.add(CUSTOM_CLASS);

    this.createCustomSelectLabel();
    this.createCustomSelectBox();
    this.bindEvents();
  }

  bindEvents() {
    body.addEventListener('click', (e) => this.handleBodyClick(e));
    this.ui.label.addEventListener('click', () => this.handleLabelClick());
  }

  bindMobileEvents() {
    this.ui.select.addEventListener('change', () => this.handleSelectChange());
  }

  handleBodyClick(e) {
    if (!this.ui.element.contains(e.target)) {
      this.ui.list.hidden = true;
    }
  }

  handleLabelClick() {
    if (!this.ui.element.classList.contains('form__item--disabled')) {
      this.ui.list.hidden = false;
    }
  }

  createCustomSelectLabel() {
    const selectedOption = this.ui.select.options[this.ui.select.selectedIndex];
    this.ui.labelText = document.createElement('span');
    this.ui.labelText.innerHTML = selectedOption.innerHTML;

    if (selectedOption.disabled) {
      this.ui.label.classList.add('select__label--disabled');
    }

    this.ui.label.append(this.ui.labelText);
  }

  createCustomSelectBox() {
    this.ui.list = document.createElement('ul');
    this.ui.list.classList.add('csb__list');
    this.ui.list.hidden = true;

    this.ui.options.map((option, i) => {
      const itemButtonLabel = document.createElement('span');
      const itemButton = document.createElement('button');
      const item = document.createElement('li');
      const variationAttributeHook = this.ui.select.getAttribute('variation-attribute-hook');

      if (option.getAttribute('hidden') === '') item.classList.add('u-hidden');

      itemButtonLabel.classList.add('csb__button-label');
      itemButtonLabel.innerHTML = option.innerHTML.replace(/-/g, '&#8209;');

      itemButton.addEventListener('click', (e) => this.handleItemButtonClick(e, itemButton));
      itemButton.classList.add('csb__button');
      itemButton.dataset.index = i;
      itemButton.append(itemButtonLabel);

      if (variationAttributeHook) itemButton.setAttribute('variation-attribute-hook', variationAttributeHook);

      if (option.disabled) {
        itemButton.classList.add('csb__button--disabled');
      }

      if (option.selected) {
        itemButton.classList.add('csb__button--selected');
      }

      item.classList.add('csb__item');
      item.append(itemButton);

      this.ui.list.append(item);
    });

    this.ui.element.append(this.ui.list);
  }

  handleCloseButtonClick() {
    this.ui.list.hidden = true;
  }

  handleItemButtonClick(e, button) {
    e.preventDefault();

    this.ui.select.selectedIndex = parseInt(button.dataset.index, 10);
    this.ui.select.dispatchEvent(new Event('change'));

    const selectedOption = this.ui.select.options[this.ui.select.selectedIndex];
    this.ui.labelText.innerHTML = selectedOption.innerHTML;
    this.ui.element.removeChild(this.ui.list);

    if (selectedOption.disabled) {
      this.ui.label.classList.add('select__label--disabled');
    } else {
      this.ui.label.classList.remove('select__label--disabled');
    }

    this.createCustomSelectBox();
  }

  handleSelectChange() {
    const { select } = this.ui;

    if (select.selectedIndex === 0) {
      select.classList.remove('select__input--selected');
    } else {
      select.classList.add('select__input--selected');
    }
  }
}

export default CustomSelectBox;
